import React, { Component } from "react";
import Header from "./HeaderTwo";
import Footer from "./Footer";
import Items from "./CartItems";
import { 
    Container
} from "react-bootstrap";
import { Helmet } from "react-helmet";
import { Redirect } from 'react-router-dom';
import { metaTitle, mobile, currency } from '../config';

class Cart extends Component {

  state = {
    null_item: false,
    cart_item: [],
    table: 'Take away',
    items: [],
    total_items: 0,
    whatsapp_string: '',
    total_amount: 0
  }

  componentDidMount(){
    const table = sessionStorage.getItem("table");
    const cart = sessionStorage.getItem('cart');
    let cart_item = [];
    if (cart) {
      cart_item = JSON.parse(cart);
    }else{
      this.setState({ null_item: true });
    }
    this.setState({
      cart_item: cart_item,
      table: table
    });
  }

  addItems = (items) => {
    this.setState({
      items: items
    });
    this.whatsApp();
  }

  increment = (id) =>{
    let cart = this.state.cart_item;
    cart.forEach((item, key) => {
      if(item.id === id){
        let i_count = item.count+1;
        cart[key] = {
          id: id,
          count: i_count,
          note: item.note
        }
        return true;
      }
    });
    sessionStorage.setItem('cart', JSON.stringify(cart));
    this.setState({
      cart_item: cart
    });
    this.whatsApp();
  }

  decrement = (id) =>{
    let cart = this.state.cart_item;
    cart.forEach((item, key) => {
      if(item.id === id){
        let i_count = item.count-1;
        if(i_count <= 0){
          i_count = 0;
        }
        cart[key] = {
          id: id,
          count: i_count,
          note: item.note
        }
        return true;
      }
    });
    sessionStorage.setItem('cart', JSON.stringify(cart));
    this.setState({
      cart_item: cart
    });
    this.whatsApp();
  }

  addNote = (event) =>{
    let id = event.target.name;
    let value  = event.target.value;
    let cart = this.state.cart_item;
    cart.forEach((item, key) => {
      if(item.id === id){
        cart[key] = {
          id: id,
          count: item.count,
          note: value
        }
        return true;
      }
    });
    sessionStorage.setItem('cart', JSON.stringify(cart));
    this.setState({
      cart_item: cart
    });
    this.whatsApp();
  }

  round = (value) => {
    let num = parseFloat(value).toFixed(2);
    return num;
  }

  round_total = (total) => {
    let totals = this.round(total);
    this.setState({
      total_amount: totals
    });
    return totals;
  }

  whatsApp (){
    let table = (this.state.table === 'Take away') ? this.state.table : 'Table No: '+this.state.table;
    let product = this.state.items;
    let cart = this.state.cart_item;
    let i_count = 0;
    let i_note = '';
    let i_total = 0;
    let s_total = 0;
    let t_items = 0;

    let data = '*'+table+'* \n\n';
    cart.forEach((cart_item) => {
      i_count = cart_item.count;
      i_note = cart_item.note;
      if(i_count !== 0){
        product.forEach((product_item) => {
          if(cart_item.id === product_item.id){
            t_items += i_count;
            i_total = product_item.price*i_count;
            s_total += i_total;
            data += '*'+product_item.title+' ('+product_item.category+')* \n';
            data += this.round(product_item.price)+' '+currency+' x'+i_count+' ='+this.round(i_total)+' '+currency+' \n';
            data += '_'+i_note+'_ \n';
            data += '\n';
          }
        });
      }
    });

    data += '\n';
    data += '*Total Amount: '+this.round(s_total)+' '+currency+'*';

    this.setState({
      whatsapp_string: data,
      total_items: t_items,
      total_amount: s_total
    });
  }

  deleteItem = (items) => {
    let cart = this.state.cart_item;
    cart.forEach((item, key) => {
      if(item.id === items){
        cart.splice(key, 1);
        return true;
      }
    });
    sessionStorage.setItem('cart', JSON.stringify(cart));
    this.setState({
      cart_item: cart
    });
    this.whatsApp();
  }

  clear = () => {
    sessionStorage.removeItem('cart');
    this.setState({
      null_item: true
     });
  }

  render() {
    if(this.state.null_item === true){
      return <Redirect to='/order' />
    }
    
    return (
      <React.Fragment>
        <Helmet>
          <meta charSet="utf-8" />
          <title>{ metaTitle('Cart') }</title>
        </Helmet>
        <Header />
        <Container>
          <Items clear={this.clear} increment={this.increment} decrement={this.decrement} deleteItem={this.deleteItem} addNote={this.addNote} cart_item={this.state.cart_item} table={this.state.table} addItems={this.addItems} round={this.round}/>
        </Container>
        <div className="whatsapp-share">
          <a href={`https://wa.me/${mobile}?text=${encodeURI(this.state.whatsapp_string)}`} target="_blank" rel="noopener noreferrer" className="whatsapp-share-link">
            <i className="icon ion-logo-whatsapp"></i>
            <label>Submit order in whatsapp<br/> {this.state.total_items} items. Pay {this.round(this.state.total_amount)} {currency}.</label>
          </a>
        </div>
        <Footer />
      </React.Fragment>
    );
  }
}
export default Cart;
